import s from './TitleDivider.module.sass'

import { ImageBox, Copy } from 'shared-components'

function TitleDivider({ title, copy }: any) {
    return (
        <div className={s.TitleDivider}>
            <div className={s.Title}>{title && <h2 dangerouslySetInnerHTML={{ __html: title }} />}</div>
            <div className={s.Copy}>{copy && <Copy copy={copy} />}</div>
        </div>
    )
}

export default TitleDivider
